var cart = {


  setNumbers: function(e) {
    if(e) e.preventDefault();

    var dir      = parseInt($(this).data('step'));
        dir      = isNaN(dir) ? 0 : dir;
    var input    = $(this).closest('.cart-group').find('input[name="qty"]');
    var submit   = $(this).closest('.cart-form').find('button[type="submit"]');
    var max      = parseInt(input.attr('max'));
    var min      = parseInt(input.attr('min'));
    var value    = parseInt(input.val());
        value    = isNaN(value) ? min : value;
    var newval   = (value + dir) > max ? max : (value + dir) < min ? min : (value + dir);
    var current  = $(this).closest('.cart-group').find('input[name="current"]').val();
        current  = parseInt(current);
    var btnclass = 'btn rounded btn-sm form-control py-0 ';
    var icon     = newval == 0 ? 'fa fa-trash'           : (min == 0 ? 'fa fa-sync' : 'fa fa-cart-plus'    );
    var button   = newval == 0 ? btnclass + 'btn-danger' : (min == 0 ? btnclass + 'btn-primary' : btnclass + 'btn-dark');
    var str      = newval == 0 ? cart.actions[2]         : (min == 0 ? cart.actions[1]          : cart.actions[0]);

    input.val(newval);

    submit.attr('class', button);
    submit.find('i').attr('class', icon);
    submit.find('span').text(str);

    submit.toggleClass('disabled', newval == current);

  },

  setMessage: function(form) {
    var added     = form.find('input[name="current"]');
    var added     = parseInt(added.val());
    var inputstr  = form.find('input[name="inputstr"]').val();
    var backorder = form.find('input[name="backorder"]');
    var backorder = parseInt(backorder.val());
    var status    = form.find('.cart-status');

    if(added > 0){
      status.css({transform: 'scaleX(1)'}).html(

        $('<span>').append(

          $('<i>').addClass('fa fa-check text-success')
        ).append(
          ' ' + inputstr,
        )
      );
    } 

    else{
      status.css({transform: 'scaleX(0)'});
      setTimeout(function() {status.html($('<span>').addClass('overflow-hidden').text('-'))}, 150);
    } 

    if(backorder > 0) status.append(
      $('<span>').append(
        $('<i>').addClass('fa fa-exclamation-triangle text-warning')
      ).append(
        ' Backorder: ' + backorder,
      )
    );

    var border = added && !backorder ? 'primary' : (added && backorder ? 'warning' : 'light');
    form.attr('style', `border-left: 4px solid var(--${border}) !important`)

  },

  submit: function(e) {
    e.preventDefault();

    var form           = $(this);
    var inputCurrent   = form.find('input[name="current"]');
    var inputbackorder = form.find('input[name="backorder"]');
    var inputstr       = form.find('input[name="inputstr"]');
    var inputMin       = form.find('input[name="min"]');
    var inputQty       = form.find('input[name="qty"]');
    var spinners       = form.find('button[type="button"]');
    var button         = form.find('button[type="submit"]');
    var currenticon    = button.find('i').attr('class');
    var inputs         = {};
    var $input         = form.find('input');
    var boxtitle       = form.find('.box-title');
    var status         = form.find('.cart-status');
    var swapCurrent    = inputCurrent.val();

    for (var i = 0; i < $input.length; i++) {
      inputs[$($input[i]).attr('name')] = $($input[i]).val();
    }

    inputCurrent.val(inputQty.val());


    var stop = cart.onUpdating ? cart.onUpdating(form) : -1;

    if(stop >= 0) {
      setTimeout(function() {
        inputCurrent.val(swapCurrent);
        inputQty.val(swapCurrent);
        inputQty.trigger('input');
      }, stop);
      return;
    }

    button.addClass('disabled');
    button.find('i').attr('class', 'fa fa-spinner fa-pulse');
    inputQty.prop('disabled', true);
    spinners.addClass('disabled').prop('disabled', true).removeClass('bg-white').addClass('bg-light');
    $.ajax({
      url: `/${$('html').attr('lang')}/cart/update`,
      type: 'POST',
      data: inputs,
    })
    .done(function(response) {
      inputbackorder.val(response.backorder);
      inputCurrent.val(response.in_cart);
      inputstr.val(response.addedstr);
      inputMin.val(response.in_cart > 0 ? 0 : 1)
      inputQty.attr('min', response.in_cart > 0 ? 0 : 1).val(response.in_cart == 0 ? 1 : response.in_cart);
      inputQty.trigger('input');


      boxtitle.toggleClass('box-title-absolute', response.in_cart > 0);

      cart.setMessage(form);

      $('.cart-total').text(response.count > 99 ? '99+' : response.count).toggleClass('hidden', response.count == 0);

      if(cart.onSuccess) cart.onSuccess(response, form);


    })
    .fail(function(xhr) {
      inputQty.val(inputCurrent.val() == 0 ? 1 : inputCurrent.val());
      button.find('i').attr('class', currenticon);
      button.removeClass('disabled').prop('disabled', false);

      boxtitle.toggleClass('box-title-absolute', true);

      status.css({transform: 'scaleX(1)'}).html(
        $('<i>').addClass('fa fa-exclamation-triangle text-danger')
      )
      .append(
        $('<strong>').text(` Error ${xhr.status}: `)
      )
      .append(
        xhr.statusText == 'error' ? 'No connecton' : xhr.statusText
      );
      form.attr('style', `border-left: 4px solid var(--danger) !important`)

      inputCurrent.val(swapCurrent);

    })
    .always(function() {
      inputQty.prop('disabled', false);
      spinners.removeClass('disabled').prop('disabled', false).removeClass('bg-light').addClass('bg-white');
      button.blur();
    });

  },

  render: function(form) {

    var value = $(form).find('input[name="current"]').val();
        value = value > 0 ? value : 1;
    $(form).find('input[name="qty"]').attr('value', value).val(value).attr('min', $(this).find('input[name="min"]').val());

    $(form).find('.input-group input, .input-group button, .input-group select').bind('focusin', function(event) {
      $(this).closest('.input-group').addClass('active');
    }).bind('focusout', function(event) {
      $(this).closest('.input-group').removeClass('active');
    });

    if(!cart.actions) cart.actions = $(form).data('actions').split(',');

    cart.setMessage(form);

    $(form).find('.cart-group button').bind('click', cart.setNumbers);
    $(form).find('.cart-group input[name="qty"]').bind('input', cart.setNumbers).trigger('input');
    $(form).unbind('submit').bind('submit', cart.submit);
    $(form).addClass('rendered');
  },
 

  init: function() {

    jQuery(document).ready(function($) {
      $('.cart-form').each(function(index, el) {

        cart.render($(this));

      });
    });

    
  },

}

cart.init();

module.exports = {
  render: function(form) {

    $('.cart-form:not(.rendered)').each(function(index, el){
      cart.render($(el));
    });

  },

  onSuccess: function(handler) {
    cart.onSuccess = handler;
  },

  onUpdating: function(handler) {
    cart.onUpdating = handler;
  },

  stopPropagation: function(timeout) {
    return timeout;
  },
}